import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search } from 'lucide-react';

export default function WikiSearchBar() {
    const [q, setQ] = useState('');
    const navigate = useNavigate();

    const handleSearch = (e) => {
        e.preventDefault();
        if (q.trim()) {
            navigate(`/wiki/search?q=${encodeURIComponent(q.trim())}`);
        }
    };

    return (
        <form onSubmit={handleSearch} style={{ position: 'relative', flex: 1, maxWidth: '500px' }}>
            <input
                type="text"
                value={q}
                onChange={(e) => setQ(e.target.value)}
                placeholder="Search wiki..."
                style={{
                    width: '100%',
                    padding: '0.5rem 0.5rem 0.5rem 2.25rem',
                    background: 'var(--bg-tertiary)',
                    border: '1px solid var(--border)',
                    borderRadius: '6px',
                    color: 'var(--text-primary)',
                    fontSize: '0.875rem',
                }}
            />
            <Search
                size={16}
                style={{
                    position: 'absolute',
                    left: '0.65rem',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: 'var(--text-secondary)',
                    pointerEvents: 'none',
                }}
            />
        </form>
    );
}